import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { APPS } from './meta';
var localSubdomainRegex = "local-(".concat(APPS.join('|'), ")");
export var localSubdomainToAppName = function localSubdomainToAppName(subdomain) {
  var _ref = subdomain.match(localSubdomainRegex) || [],
      _ref2 = _slicedToArray(_ref, 2),
      app = _ref2[1];

  return app;
};